export default __webpack_public_path__ + "static/media/halal.8fc0a222.png";